module.exports = __webpack_public_path__ + "/img/2dc0bb274c7dffba6fa222a8e1e32d50.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/ads_bg_m.png
 ** module id = 28
 ** module chunks = 0 4 5
 **/